import { render } from "./TokenManagement.vue?vue&type=template&id=34da061a&scoped=true"
import script from "./TokenManagement.vue?vue&type=script&lang=js"
export * from "./TokenManagement.vue?vue&type=script&lang=js"

import "./TokenManagement.vue?vue&type=style&index=0&id=34da061a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34da061a"]])

export default __exports__